import React from 'react';

import { SpinnerLoaderView } from './SpinnerLoader.view';

export interface SpinnerLoaderProps {
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  text?: string;
  shouldHideContent?: boolean;
}

export const SpinnerLoader: React.FC<SpinnerLoaderProps> = ({
  size,
  text,
  shouldHideContent = false,
}: SpinnerLoaderProps) => (
  <SpinnerLoaderView
    size={size}
    text={text}
    shouldHideContent={shouldHideContent}
  />
);
